import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = {
  class: "grid-x",
  id: "app-topbar"
}
const _hoisted_2 = { class: "lang" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_topbar_user_component = _resolveComponent("topbar-user-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      id: "topbar-logo",
      class: "cell shrink grid-x align-center align-middle"
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "horstCOSMOS Logo",
          loading: "lazy"
        }, null, -1)
      ]))]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "#",
        id: "de",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLanguage && _ctx.handleLanguage(...args))),
        class: _normalizeClass(_ctx.$i18n.locale === 'de' && 'selected')
      }, "DE", 2),
      _createElementVNode("a", {
        href: "#",
        id: "en",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLanguage && _ctx.handleLanguage(...args))),
        class: _normalizeClass(_ctx.$i18n.locale === 'en' && 'selected')
      }, "EN", 2)
    ]),
    _createVNode(_component_topbar_user_component, {
      id: "topbar-user",
      class: "cell shrink"
    })
  ]))
}